<div class="flex app-calculation-input-container">
    <input [ngModel]="result" (ngModelChange)="onValueChange($event)" matInput type="number" step="any" [disabled]="disabled" />
    <span class="flex relative cursor-pointer" (click)="onCalculatorClick()">
        <div class="badge" *ngIf="_formula"></div>
        <fa-icon icon="calculator" matTooltip="berechnen" matTooltipPosition="left"></fa-icon
    ></span>
</div>
